export default __webpack_public_path__ + "static/media/tpnl.b14511cb.mp4";